const dialog = document.getElementById('omt-quickview-dialog');
const body = document.getElementById('omt-quickview-body');

async function openQuickView(url) {
  if (!dialog || !body) return;
  body.innerHTML = '';
  dialog.showModal();
  const response = await fetch(`${url}?view=quick-view`);
  body.innerHTML = await response.text();
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.js-quick-view');
  if (!trigger) return;
  event.preventDefault();
  openQuickView(trigger.dataset.productUrl);
});

dialog?.querySelector('[data-omt-close]')?.addEventListener('click', () => dialog.close());
dialog?.addEventListener('click', (event) => {
  if (event.target === dialog) dialog.close();
});
